module.exports = __webpack_public_path__ + "images/Cloudflare-e307da.png";